<template>
  <div class="board-wrapper position-relative w-100 m-4 bg-light">
    <div class="board-content h-100">
      <Board v-if="items.length" :title="title" :target="$wordUp(target)" @action="emitAction">
        <template v-slot:icon>
          <i class="icon-percent" style="font-size: 5rem">
            <span class="path1"></span>
            <span class="path2"></span>
            <span class="path3"></span>
            <span class="path4"></span>
            <span class="path5"></span>
          </i>
        </template>
        <BoardItems
          v-if="!loading"
          class="board-content"
          :modal="'#EditorModal'"
          :templateEnable="existTemplates"
          :target="target"
          :items="items"
          v-bind="boardSettings"
          @action="emitAction" />
        <div v-else class="position-relative" style="height: calc(100% - 218px)">
          <Spinner class="text-primary" :size="'lg'" :center="true" />
        </div>
      </Board>
      <BoardPlaceholder
        v-else-if="!loading"
        class="position-center"
        :title="title"
        :target="$wordUp(target)"
        :modal="'#EditorModal'"
        :description="`Aún no tienes ninguna ${target} registrada.`"
        @click="emitAction('create', target)">
        <i class="icon-percent" style="font-size: 5rem">
          <span class="path1"></span>
          <span class="path2"></span>
          <span class="path3"></span>
          <span class="path4"></span>
          <span class="path5"></span>
        </i>
      </BoardPlaceholder>
    </div>
    <Notifications :single="'true'" :hide-after="5000"></Notifications>
    <button ref="create" class="d-none" @click="createItem"></button>
    <button ref="update" class="d-none" @click="updateItem"></button>
    <button ref="remove" class="d-none" @click="remove(itemToDelete)"></button>
    <button ref="reset" class="d-none" @click="resetInputs"></button>
    <button
      ref="masterModal"
      class="d-none"
      data-bs-toggle="modal"
      data-bs-target="#MasterEnableModal"></button>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex';

import Board from '@/components/boards/Board.vue';
import Spinner from '@/components/common/Spinner.vue';
import Notifications from '@voerro/vue-notifications';
import BoardItems from '@/components/boards/BoardItems.vue';
import BoardPlaceholder from '@/components/boards/BoardPlaceholder.vue';

export default {
  name: 'BoardAdvertising',
  components: {
    Board,
    Spinner,
    BoardItems,
    Notifications,
    BoardPlaceholder,
  },
  mounted() {
    if (this.scopes.includes('Advertising')) {
      this.getAll();
    } else {
      this.$emit('goTo', 'disabled');
    }
  },
  data() {
    return {
      title: 'Publicidad',
      target: 'anuncio',
      itemToUpdate: null,
      itemToDelete: null,
      boardSettings: {
        cols: [
          {
            header: 'Nombre',
            width: '200px',
            prop: 'name',
          },
          {
            header: 'Vigencia',
            width: '120px',
            prop: 'expiration',
          },
          {
            header: 'Descripción',
            width: 'auto',
            prop: 'description',
          },
        ],
        actions: ['edit', 'delete'],
      },
    };
  },
  props: {
    existTemplates: Boolean,
  },
  computed: {
    ...mapState({
      advertising: (state) => state.advertising,
      templates: (state) => state.templates,
      profile: (state) => state.profile.info,
    }),
    items() {
      const parseItems = this.advertising.items.map((p) => ({
        ...p,
        expiration: p.expiration ? this.$moment(p.expiration).format('DD-MM-YYYY') : 'N/A',
      }));
      return parseItems;
    },
    loading() {
      return this.advertising.loading;
    },
    scopes() {
      return this.profile.plan.scopes.map((s) => s.name);
    },
    error() {
      return this.advertising.error;
    },
  },
  methods: {
    ...mapActions('advertising', [
      'getAll',
      'create',
      'update',
      'remove',
      'resetInputs',
      'setItemValues',
    ]),
    emitAction(action, target, id) {
      this.$emit('action', action, target, id);

      if (action === 'update') {
        this.itemToUpdate = id;
        this.setItemValues(id);
      } else if (action === 'remove') {
        this.itemToDelete = id;
      }
    },
    createItem() {
      try {
        this.create().then((id) => {
          if (this.templates.items.length) {
            this.$emit('action', 'create', 'anuncio', id);
            this.$refs.masterModal.click();
          }
          this.$parent.$refs.editorModal.$refs.closeEditor.click();
          // this.resetInputs();
        });
      } catch (error) {
        console.log(error.message);
      }
    },
    updateItem() {
      this.update(this.itemToUpdate).then((err) => {
        if (!err) {
          const updateInTemplate = this.advertising.inputs.some(
            (inp) => inp.updated && inp.editInTemplate,
          );

          if (this.templates.items.length && updateInTemplate) {
            this.$emit('action', 'update', 'anuncio', this.itemToUpdate);
            this.$refs.masterModal.click();
          }
          this.$parent.$refs.editorModal.$refs.closeEditor.click();
          // this.resetInputs();
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
